import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createMuiTheme } from '@material-ui/core/styles';
import { StylesProvider, ThemeProvider } from '@material-ui/styles';
import * as Sentry from '@sentry/browser';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import { store, persistor } from './store';
import sentryConfiguration from './sentryConfiguration';

if (process.env.REACT_APP_STAGE === 'prod') {
  Sentry.init({
    dsn: 'https://66e3f4616ea54faf98147be734d3ea66@sentry.io/1469580',
    release: sentryConfiguration.version,
    production: true
  });
}

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#5ccaf4'
    }
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: '#fff'
      },
      contained: {
        textTransform: 'none'
      }
    }
  }
});

ReactDOM.render(
  <Provider store={store}>
    <StylesProvider injectFirst>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </PersistGate>
    </StylesProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
